var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewPrompt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35714 3.5H12.5V8.64286M8.64286 12.5L3.5 12.5V7.35714",
    stroke: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPrompt);
export default __webpack_public_path__ + "static/media/view_prompt.e96de195396a7829c91f93a1511b5c55.svg";
export { ForwardRef as ReactComponent };